import { useEffect, useRef, useState } from "react"
import styled from "styled-components"

import { useGetInAppUnreadCountQuery } from "store/api/notificationApi"
import { ReactComponent as BellIcon } from "assets/svg/menu-notification.svg"

import { NotificationCenterModal } from "modals/NotificationCenterModal"

const IconWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 40px;
  height: 40px;

  &:hover {
    opacity: 0.8;
  }

  svg {
    width: 40px;
    height: 40px;
  }
`

const Badge = styled.div`
  position: absolute;
  top: 2px;
  right: 4px;
  min-width: 16px;
  height: 16px;
  padding: 0 2px;
  background: #ef4444;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 11px;
  color: white;
`

export const NotificationIcon = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const iconRef = useRef<HTMLDivElement>(null)

  const { data, refetch } = useGetInAppUnreadCountQuery()

  useEffect(() => {
    const interval = setInterval(() => {
      refetch()
    }, 60000)

    return () => clearInterval(interval)
  }, [refetch])

  const handleClick = () => {
    setIsModalOpen(!isModalOpen)
  }

  const handleClose = () => {
    setIsModalOpen(false)
  }

  const unreadCount = data?.data || 0
  const hasUnread = unreadCount > 0
  const displayCount = unreadCount > 99 ? "99+" : unreadCount

  return (
    <>
      <IconWrapper ref={iconRef} onClick={handleClick}>
        <BellIcon />
        {hasUnread && <Badge>{displayCount}</Badge>}
      </IconWrapper>
      {isModalOpen && <NotificationCenterModal onClose={handleClose} triggerRef={iconRef} />}
    </>
  )
}
